import React from 'react';
import { useNavigate } from 'react-router-dom';

const Success: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="booking-confirmation" style={{padding: '2rem', textAlign: 'center'}}>
      <h1>Payment Successful!</h1>
      <p>Your booking has been received. We will contact you soon to confirm the details.</p>
      <button style={{marginTop: '2rem'}} onClick={() => navigate('/')}>Return Home</button>
    </div>
  );
};

export default Success;
